import { Box, Typography } from "@mui/material";
import { Spa as DietIcon, ReportProblem as AllergenIcon } from "@mui/icons-material";
import { t } from "../dashboard/coach/coachTokens";

/** Hebrew labels for the fixed diet-flag / allergen enum vocabularies (server: FoodDietFlag / FoodAllergen). */
const DIET_LABELS = {
  KETO: "קטו",
  VEGAN: "טבעוני",
  VEGETARIAN: "צמחוני",
  PESCATARIAN: "פסקטריאני",
  GLUTEN_FREE: "ללא גלוטן",
  DAIRY_FREE: "ללא חלב",
  PALEO: "פליאו",
};

const ALLERGEN_LABELS = {
  NUTS: "אגוזים",
  PEANUTS: "בוטנים",
  DAIRY: "חלב",
  EGGS: "ביצים",
  GLUTEN: "גלוטן",
  SOY: "סויה",
  SESAME: "שומשום",
  FISH: "דגים",
  SHELLFISH: "פירות ים",
};

const Chip = ({ label, tone }) => {
  const Icon = tone === "diet" ? DietIcon : AllergenIcon;
  const colors =
    tone === "diet"
      ? { bg: t.greenLight, color: t.greenText, border: "rgba(1,187,167,.25)" }
      : { bg: "#FEF3C7", color: "#B45309", border: "rgba(180,83,9,.25)" };
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        background: colors.bg,
        color: colors.color,
        border: `1px solid ${colors.border}`,
        borderRadius: "20px",
        px: "10px",
        py: "3px",
      }}
    >
      <Icon sx={{ fontSize: 14 }} />
      <Typography sx={{ fontSize: "12px", fontWeight: 600, lineHeight: 1.2 }}>{label}</Typography>
    </Box>
  );
};

/** Diet-suitability chips (green) + allergen chips (amber) for a food, from its enrichment. */
const DietAllergenChips = ({ food }) => {
  const diet = (food?.dietFlags || []).filter((d) => DIET_LABELS[d]);
  const allergens = (food?.allergens || []).filter((a) => ALLERGEN_LABELS[a]);
  if (!diet.length && !allergens.length) return null;

  return (
    <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
      {diet.map((d) => (
        <Chip key={`diet-${d}`} tone="diet" label={DIET_LABELS[d]} />
      ))}
      {allergens.map((a) => (
        <Chip key={`allergen-${a}`} tone="allergen" label={`מכיל ${ALLERGEN_LABELS[a]}`} />
      ))}
    </Box>
  );
};

export default DietAllergenChips;
